<template>

    <v-navigation-drawer
        v-model="drawer"
        clipped
        fixed
        app
        enable-resize-watcher
        width="220"
        :mini-variant="mini"
    >

        <v-list dense class="pt-0">
            <!-- MENU ITEMS -->
            <v-list-item dense v-for="item in items"
                         :key="item.id"
                         :class="isRouteActive(item.route) ? 'primary arrow_box': 'secondary menu_item'"
                         ripple
                         @click="itemClicked(item)"
                         v-if="authorize(item)">

                <v-list-item-action class="mr-4">
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>

                <div v-show="isRouteActive(item.route)" class="arrowBox">
                    <v-btn icon>
                        <v-icon large color="grey lighten-3">mdi-menu-right</v-icon>
                    </v-btn>
                </div>

            </v-list-item>

        </v-list>

    </v-navigation-drawer>

</template>

<script>

export default {

    data: () => ({
        drawer: true,
        mini: false,
        activeRoute: '/spa/dashboard',  // Default
        items: [
            {name: 'Dashboard', route: '/spa/dashboard', permission: 'view dashboard', icon: 'mdi-view-dashboard'},
            {
                name: 'Settings',
                route: '/spa/settings',
                permission: 'view panel settings',
                icon: 'mdi-cog'
            },
            {
                name: 'Data Variables',
                route: '/spa/datavariables',
                permission: 'view data variables',
                icon: 'mdi-database'
            },
            {name: 'Segments', route: '/spa/segments', permission: 'run queries', icon: 'mdi-target'},
            {
                name: 'Projects',
                route: '/spa/projectmanager',
                permission: 'view projects',
                icon: 'mdi-folder-clock-outline'
            },
            {
                name: 'Panelist Manager',
                route: '/spa/panelistmanager',
                permission: 'view panelists',
                icon: 'mdi-account-group'
            },
            // {
            //     name: 'Communications Hub',
            //     route: '/spa/communications',
            //     permission: 'view panel settings',
            //     icon: 'mdi-at'
            // },
            {
                name: 'Panel Health',
                route: '/spa/health',
                permission: 'view health reports',
                icon: 'mdi-heart-pulse'
            },
            {
                name: 'Financial Reports',
                route: '/spa/financial',
                permission: 'view financial reports',
                icon: 'mdi-finance'
            },
            {
                name: 'Sub Panels',
                route: '/spa/subpanels',
                permission: 'view sub panels',
                icon: 'mdi-sitemap'
            },
            {
                name: 'Rewards',
                route: '/spa/rewards',
                permission: 'view rewards',
                icon: 'mdi-star-circle'
            },
            {
                name: 'Redemptions',
                route: '/spa/redemptions',
                permission: 'view rewards',
                icon: 'mdi-wallet-giftcard'
            },
            {
                name: 'Recruitment Sources',
                route: '/spa/recruitmentsources',
                permission: 'view recruitment sources',
                icon: 'mdi-magnet-on'
            },
            {
                name: 'Registration',
                route: '/spa/registrations',
                permission: 'view sub panels',
                icon: 'mdi-account-clock'
            },
            {
                name: 'Clients',
                route: '/spa/clients',
                permission: 'view clients',
                icon: 'mdi-card-account-details-outline'
            },
            {
                name: 'Feedback',
                route: '/spa/feedback',
                permission: 'view feedback',
                icon: 'mdi-comment-quote-outline',
            },
            {
                name: 'Panelist Importer',
                route: '/spa/panelistimporter',
                permission: 'import panelists',
                icon: 'mdi-progress-upload'
            },
            {
                name: 'User Management',
                route: '/spa/usermanager',
                permission: 'view users',
                icon: 'mdi-shield-account'
            },
            {
                name: 'Locales',
                route: '/spa/locales',
                permission: 'view panel settings',
                icon: 'mdi-earth',
            },
            {
                name: 'External Suppliers',
                route: '/spa/external-suppliers',
                permission: 'view panel settings',
                icon: 'mdi-network-outline',
                feature: 'project_router_mode'
            },
            {
                name: 'Downloads',
                route: '/spa/downloads',
                permission: 'view downloads',
                icon: 'mdi-cloud-download-outline'
            },
        ]
    }),

    methods: {

        authorize(item) {
            if (item.permission && !this.hasPermission(item.permission)) return false;
            if (item.role && !this.hasRole(item.role)) return false;
            if (item.feature && !this.hasFeature(item.feature)) return false;
            return true;
        },

        isRouteActive(route) {
            return this.activeRoute === route;
        },

        itemClicked(item) {

            if (typeof item.route === 'function') {
                item.route();
            } else {
                // Check if route is already active as this disabled error that vue router throws!
                if (this.$route.path !== item.route) {
                    this.activeRoute = item.route;
                    this.$router.push(item.route);
                }
            }
        },
    },

    watch: {
        $route(to) {

            // Handle programmatic route change i.e. project participant list -> edit panelist
            const found = this.items.find(item => {
                const basePath = to.path.substring(0, item.route.length);
                return item.route === basePath;
            });

            if (found) {
                this.activeRoute = found.route;
            }
        }
    },

    created() {

        Bus.$on('navigation-drawer-cycle', (mode) => {

            if (mode === "wide") {
                this.mini = false;
                this.drawer = true;
            }
            if (mode === "narrow") {
                this.drawer = true;
                this.mini = true;
            }
            if (mode === "hidden") this.drawer = false;
        });

        Bus.$on('navigation-drawer', (value) => {
            this.drawer = value;
        });

        this.activeRoute = this.$route.path;
    },
}

</script>

<style scoped>

.menu_item {
    height: 40px;
}

.arrowBox {
    position: absolute;
    right: 0px;
}

.arrow_box {
    position: relative;
    height: 40px;
}

</style>
